import { render, staticRenderFns } from "./TEXTDISPLAY.vue?vue&type=template&id=245a6d7c&scoped=true&"
import script from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
export * from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
import style0 from "./TEXTDISPLAY.vue?vue&type=style&index=0&id=245a6d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a6d7c",
  null
  
)

/* custom blocks */
import block0 from "./TEXTDISPLAY.vue?vue&type=custom&index=0&blockType=div&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports